export default "/images/618fe1923e0aaf7e1db477d4f54f94eb.png";